module.exports = __webpack_public_path__ + "img/p-two-step-13.355e0664.png";